import React,{useEffect} from 'react';
import PropTypes from 'prop-types';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { SchemaProvider } from './context/shemaContext';
import { CartContextProvider } from './context/CartContext';
import { UserProvider } from './context/UserContext';
import { ListingContextProvider } from './context/ListingContext';
import { ContextProvider } from './context/store';
import { QuarticonContextProvider } from './context/QuarticonContext';
import { CompareProvider } from './hooks/useCompare';
import { PopupProvider } from './context/PopupContext';
import { ConfigProvider, useConfig } from './context/ConfigContext';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import TagManager from 'react-gtm-module';
import * as Sentry from '@sentry/react';

const InnerProviders = ({ children }) => {
    const {config} = useConfig();

    const {google_client_id, gtm_id, sentry}=config

    const tagManagerArgs = {
        gtmId: gtm_id
    }
    // Initialize Sentry
    // useEffect(() => {
    //     if (typeof window !== 'undefined' && sentry?.enabled && sentry?.url) {
    //         try {
    //             Sentry.init({
    //                 dsn: sentry.url,
    //                 environment: process.env.NODE_ENV || 'development',
    //                 integrations: [
    //                     Sentry.browserTracingIntegration(),
    //                     Sentry.replayIntegration(),
    //                 ],
    //                 tracesSampleRate: 1.0,
    //                 replaysSessionSampleRate: 0.1,
    //                 replaysOnErrorSampleRate: 1.0,
    //             });
    //             console.log('Sentry initialized');
    //         } catch (error) {
    //             console.error('Failed to initialize Sentry:', error);
    //         }
    //     }
    // }, [sentry]);

    // Initialize GTM if active - moved to useEffect to prevent hydration issues
    useEffect(() => {
        if (!gtm_id) return;

        const timer = setTimeout(() => {
            try {
                TagManager.initialize(tagManagerArgs);
                console.log('GTM initialized with ID:', gtm_id);
            } catch (error) {
                console.error('Error initializing GTM:', error);
            }
        }, 1000); // Opóźnienie 1000 ms (1 sekunda)

        return () => clearTimeout(timer);
    }, [gtm_id]);

    return (
        <GoogleOAuthProvider clientId={google_client_id}>
            <CartContextProvider>
                <UserProvider>
                    <ListingContextProvider>
                        <ContextProvider>
                            <QuarticonContextProvider>
                                <CompareProvider>
                                    <PopupProvider>{children}</PopupProvider>
                                </CompareProvider>
                            </QuarticonContextProvider>
                        </ContextProvider>
                    </ListingContextProvider>
                </UserProvider>
            </CartContextProvider>
        </GoogleOAuthProvider>
    );
};

const GlobalProviders = ({ children }) => {
    return (
        <SchemaProvider>
            <I18nextProvider i18n={i18n}>
                <ConfigProvider>
                    <InnerProviders>{children}</InnerProviders>
                </ConfigProvider>
            </I18nextProvider>
        </SchemaProvider>
    );
};

GlobalProviders.propTypes = {
    children: PropTypes.node.isRequired,
};

export default GlobalProviders;